import React from 'react';
import Box from '@mui/material/Box';
import ScrollBox from '@erikdakoda/ui/components/ScrollBox';
import EmbeddedArtifact from './EmbeddedArtifact';
import type { OpenArtifactHandler } from '@erikdakoda/markdown-ui/types';

type InlineArtifactCardBodyProps = {
  type: string;
  content: string;
  title?: string;
  artifactDepth?: number;
  onOpenArtifact?: OpenArtifactHandler;
  contentReloadKey?: number;
};

/**
 * Scrollable inline artifact body for preview cards (chat and markdown editor).
 */
export default function InlineArtifactCardBody({
  type,
  content,
  title,
  artifactDepth = 0,
  onOpenArtifact,
  contentReloadKey = 0,
}: InlineArtifactCardBodyProps): React.ReactElement {
  'use memo';

  return (
    <Box
      className="inline-artifact-card-body"
      sx={{
        minWidth: 0,
        width: '100%',
        height: 400,
        minHeight: 0,
        overflow: 'hidden',
        display: 'grid',
        gridTemplateRows: '1fr',
      }}
    >
      <ScrollBox innerSx={{ padding: 2 }}>
        <EmbeddedArtifact
          type={type}
          content={content}
          title={title}
          artifactDepth={artifactDepth}
          onOpenArtifact={onOpenArtifact}
          contentReloadKey={contentReloadKey}
        />
      </ScrollBox>
    </Box>
  );
}
